<script setup lang="ts">
// import { onMounted } from 'vue';
// import { useToast } from '@/composables/useToast';

// const toast = useToast();

// Test Toast notifications
// onMounted(() => {
//   setTimeout(() => {
//     toast.success('سیستم توست آماده است!', 'آماده');
//     toast.error('سیستم توست آماده است!', 'آماده');
//     toast.warn('سیستم توست آماده است!', 'آماده');
//     toast.info('سیستم توست آماده است!', 'آماده');
//   }, 500);
// });
</script>

<template>
  <Toast />
  <NewVersionNotice />
  <component :is="$route.meta.layout || 'div'" />
</template>
